import React from 'react';
import { Box, Typography, Stack } from '@mui/material';

const getColor = (status: string) => {
  switch (status) {
    case 'warning':
      return '#fbc02d'; // amber
    case 'success':
      return '#4caf50'; // green
    case 'error':
      return '#f44336'; // red
      case 'Completed' : 
      return '#008e73'; // teal
      case 'In Progress':
      return '#3174AD'; // blue
      case 'Pending':
      return '#FFBB23'; // orange
    default:
      return '#9e9e9e'; // gray
  }
};

const StatusBadgeNote = ({ status }: { status: string }) => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        marginRight: 2, // 👈 space between badges
      }}
    >
      <Box
        sx={{
          width: 12,
          height: 12,
          borderRadius: '50%',
          backgroundColor: getColor(status),
          flexShrink: 0,
        }}
      />
      <Typography
        variant="caption"
        component="span"
        sx={{ color: '#424242', fontWeight: 'bold' }}
      >
        {status}
      </Typography>
    </Box>
  );
};

export default StatusBadgeNote;
